var map = {
	"./noble01/皮肤卡@2x.png": "5c8f",
	"./noble02/皮肤卡@2x.png": "128c",
	"./noble03/皮肤卡@2x.png": "0aff",
	"./noble04/皮肤卡@2x.png": "0b3e",
	"./noble05/皮肤卡@2x.png": "d5a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b7fe";